import React from 'react'

import Footer from '../../components/footer'
import Header from '../../components/header'

export default () => {
	return (
		<React.Fragment>
			<Header />
			<div>page content</div>
			<Footer />
		</React.Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/desktop/pages/almost/index.js